import { useEffect } from "react";
import { SmartProposalActions } from "../../../../store/SmartProposal/Actions";
import { useDispatch } from "react-redux";

const useSmartProposalActions = ({ proposalUnits , proposalLeads }) => {
  const dispatch = useDispatch();
  
  const updateGlobalState = () => {
    const smartProposalState = {
      checkedUnits: proposalUnits,
      checkedLeads: proposalLeads,
    };

    dispatch(SmartProposalActions.SmartProposalRequest(smartProposalState));
  };

  useEffect(() => {
    updateGlobalState();
  }, [proposalUnits, proposalLeads]);


};

export default useSmartProposalActions;
